module.exports = __webpack_public_path__ + "static/media/recover.704526aa.svg";